export default __webpack_public_path__ + "static/media/cover (6).c7e41a75.svg";